import { reduce } from "et3-type-guards";
import { memoize } from "lodash";
import { TOption, TPermissions } from "../../Types";
import i18n from "../../constants/i18n";
import { IComputedValue, computed } from "mobx";
import getCoreHistoryStore from "../core/core-history-store";
import getCorePersonalStore from "../core/core-personal-store";

class RoutingStore {
  USER_OPTIONS: IComputedValue<TOption[]> = computed(() => {
    const userOptionsArray: TOption[] = [
      {
        title: i18n.get("ADVANCED"),
        link: "/users/advanced",
        name: TPermissions.User,
        pageName: "USER_ADVANCED",
        pageSubName: "USER_ADVANCED",
        visibility: true
      },
      {
        title: i18n.get("EVENTS"),
        link: "/users/events",
        name: TPermissions.User,
        pageName: "USER_EVENTS",
        pageSubName: "USER_EVENTS",
        visibility: true
      },
      {
        title: i18n.get("MESSAGES"),
        link: "/users/messages",
        name: TPermissions.User,
        pageName: "USER_MESSAGES",
        pageSubName: "USER_MESSAGES",
        visibility: true
      },
      {
        title: i18n.get("PAYMENTS"),
        link: "/users/payments",
        name: TPermissions.User,
        pageName: "USER_PAYMENTS",
        pageSubName: "USER_PAYMENTS",
        visibility: true
      }
    ];
    return userOptionsArray;
  });

  getVisibleUserOptions = () => {
    const isManualKhattabaAdmin =
      getCorePersonalStore().isManualKhattabaAdmin.get();
    const pageName = getCoreHistoryStore().getPageName();
    const pageSubName = getCoreHistoryStore().getPageSubName();

    return this.USER_OPTIONS.get()
      .map((option) => {
        const optionPageName = reduce(() => option.pageName, "");
        const optionPageSubName = reduce(() => option.pageSubName, "");
        const visible = isManualKhattabaAdmin && option.visibility;
        const isSelected =
          pageName === optionPageName && pageSubName === optionPageSubName;
        return { option, visible, isSelected };
      })
      .filter(({ visible }) => visible);
  };
}

const getRoutingStore = memoize(
  () => new RoutingStore(),
  () => 1
);
export default getRoutingStore;
